import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { MaintenanceService } from '../_services/maintenance.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
    private isBrowser: boolean;

    constructor(
        private router: Router,
        private maintenanceService: MaintenanceService,
        private translateService: TranslateService,
        @Inject(PLATFORM_ID) platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                // Check for 503 maintenance mode response
                // The API returns { code: 503, msg: "...", data: { enabled, title, message, ... } }
                if (error.status === 503 && error.error?.data?.enabled) {
                    const maintenanceData = error.error.data;

                    // Store maintenance data for the maintenance page
                    this.maintenanceService.maintenanceData = {
                        enabled: true,
                        message: maintenanceData.message,
                        title: maintenanceData.title,
                        scheduledEnd: maintenanceData.scheduledEnd,
                        showCountdown: maintenanceData.showCountdown
                    };

                    // Get current language for navigation
                    const lang = this.translateService.currentLang || 'en';

                    // Only redirect if we're in the browser and not already on maintenance page
                    if (
                        this.isBrowser &&
                        !this.router.url.includes('/maintenance')
                    ) {
                        this.router.navigate([`/${lang}/maintenance`]);
                    }
                }

                // RxJS v6 style: throw the actual error object (not a factory)
                return throwError(error);
            })
        );
    }
}
